import React from 'react';
import {
  GET_QUOTES_INFORMATION_getQuotesInformation,
  GET_QUOTES_INFORMATION_getQuotesInformation_latestPeriod
} from './graphql/__generated__/GET_QUOTES_INFORMATION';
import styled from 'styled-components';
import { CardLayout } from '../../components/cardLayout/CardLayout';
import {
  formatDateAsString,
  formatDateObj,
  formatMoney
} from '../../util/formatters';
import { LayoutContainer } from '../../components/policyInfo/PolicyInfoStyles';

const RelationSpacer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
const RelationSpacerCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid green;
`;

const ExcludedSpacing = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: space-between;
  width: 280px;
  gap: 20px;
`;

const ContentSize = styled.div`
  height: 20px;
  width: 80px;
  margin-bottom: 10px;
`;

const OuterLeftWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const LeftWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const WrapperOne = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const WrapperTwo = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const WrappeThree = styled.div`
  width: 33%;
  padding: 0.5em;
  margin: 0.5em;
`;

const InnerWrapperOne = styled.div`
  width: 100%;
  color: #00008b !important;
  font-weight: 700;
  padding-bottom: 7px;
`;

const InnerWrapperTwo = styled.div`
  width: 100%;
`;

const MainWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const MainLeftWrapper = styled.div`
  width: 75%;
`;

const MainRightWrapper = styled.div`
  width: 25%;
`;

const PremiumWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5em;
`;

const TotalPremiumWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const TotalPremiumText = styled.div``;

const TotalPremiumNumber = styled.div`
  align-items: right;
`;

const TotalCostWrapper = styled.div`
  align-items: right;
  font-size: 25px;
  font-weight: bold;
`;

const Hr = styled.div`
  border-top: solid 1px #ddd;
  margin: 0.5em 0 0 0;
`;

interface periodObj {
  totalPremium: string;
  taxesAndFees: string;
  effectiveDate: Object;
  producerCodeOfRecord: string;
}

interface policyInfoProps {
  jobNumber: string | null;
  contactName: string | null;
  latestPeriod: GET_QUOTES_INFORMATION_getQuotesInformation_latestPeriod | null;
  createTime: string | null;
  status: string | null;
}

export default ({
  jobNumber,
  contactName,
  latestPeriod,
  createTime,
  status
}: policyInfoProps) => {
  // return (
  // <h1>
  //   {contactName} - Quote ({jobNumber})
  //   {latestPeriod?.producerCodeOfRecord}
  // </h1>

  return (
    <>
      <LayoutContainer style={{height: '300px'}}>
        <CardLayout title="Quote Information" bodyHeight="auto">
          <>
            <MainWrapper>
              <MainLeftWrapper>
                <OuterLeftWrapper>
                  <LeftWrapper>
                    <WrapperOne>
                      <InnerWrapperOne>Created Date:</InnerWrapperOne>
                      <InnerWrapperTwo>
                        {formatDateAsString(createTime)}
                      </InnerWrapperTwo>
                    </WrapperOne>
                    <WrapperTwo>
                      <InnerWrapperOne>Policy Inception:</InnerWrapperOne>
                      <InnerWrapperTwo>
                        {latestPeriod?.effectiveDate
                          ? formatDateAsString(latestPeriod.effectiveDate)
                          : '-'}
                      </InnerWrapperTwo>
                    </WrapperTwo>
                    <WrappeThree>
                      <InnerWrapperOne>Producer of Record</InnerWrapperOne>
                      <InnerWrapperTwo>
                        {latestPeriod?.producerCodeOfRecordOrg} (
                        {latestPeriod?.producerCodeOfRecord})
                      </InnerWrapperTwo>
                    </WrappeThree>
                  </LeftWrapper>
                </OuterLeftWrapper>
                <OuterLeftWrapper>
                  <LeftWrapper>
                    <WrapperOne>
                      <InnerWrapperOne>Status:</InnerWrapperOne>
                      <InnerWrapperTwo>{status}</InnerWrapperTwo>
                    </WrapperOne>
                    {latestPeriod?.policyNumber ? (
                      <WrapperTwo>
                        <InnerWrapperOne>Policy:</InnerWrapperOne>
                        <InnerWrapperTwo>{latestPeriod?.policyNumber}</InnerWrapperTwo>
                      </WrapperTwo>
                    ) : (
                      <WrapperTwo>
                      </WrapperTwo>
                    )}
                    <WrappeThree>
                      <InnerWrapperOne>Producer of Service</InnerWrapperOne>
                      <InnerWrapperTwo>
                        {latestPeriod?.producerCodeOfServiceOrg} (
                        {latestPeriod?.producerCodeOfService})
                      </InnerWrapperTwo>
                    </WrappeThree>
                  </LeftWrapper>
                </OuterLeftWrapper>
              </MainLeftWrapper>
              {status && status.toLowerCase() === 'quoted' && (
                <MainRightWrapper>
                  <PremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>Total Premium</TotalPremiumText>
                      <TotalPremiumNumber>
                        {latestPeriod?.totalPremium
                          ? formatMoney(latestPeriod?.totalPremium)
                          : ''}
                      </TotalPremiumNumber>
                    </TotalPremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>Taxes and Fees</TotalPremiumText>
                      <TotalPremiumNumber>
                        {latestPeriod?.taxesAndFees
                          ? formatMoney(latestPeriod?.taxesAndFees)
                          : ''}
                      </TotalPremiumNumber>
                    </TotalPremiumWrapper>
                  </PremiumWrapper>
                  <Hr />
                  <PremiumWrapper>
                    <TotalPremiumWrapper>
                      <TotalPremiumText>TOTAL COST</TotalPremiumText>
                      <TotalCostWrapper>
                        {latestPeriod?.totalCost
                          ? formatMoney(latestPeriod?.totalCost)
                          : ''}
                      </TotalCostWrapper>
                    </TotalPremiumWrapper>
                  </PremiumWrapper>
                </MainRightWrapper>
              )}
            </MainWrapper>
          </>
        </CardLayout>
      </LayoutContainer>
    </>
  );
};
